import LocalStorageProxy from '../shared/LocalStorageProxy'

const DAY = 1000 * 60 * 60 * 24

export default class PurchaseEventsRegistry {
  static addToGeneralRegistryAndCleanOld(purchaseUUID: string) {
    const purchasesRegistry = LocalStorageProxy.getItem('vp-event-registry')
    if (!purchasesRegistry) {
      const newGeneralRegistry: Record<string, number> = {}
      newGeneralRegistry[purchaseUUID] = Date.now()
      LocalStorageProxy.setItem('vp-event-registry', JSON.stringify(newGeneralRegistry))
      return
    }

    const generalRegistry = JSON.parse(purchasesRegistry)
    const newGeneralRegistry: Record<string, number> = {}

    const now = Date.now()
    for (const key in generalRegistry) {
      const timeStamp: number = generalRegistry[key]

      const diff = now - timeStamp
      if (diff > DAY) {
        LocalStorageProxy.removeItem(`vp-event-${key}`)
      } else {
        newGeneralRegistry[key] = timeStamp
      }
    }

    newGeneralRegistry[purchaseUUID] = now

    LocalStorageProxy.setItem('vp-event-registry', JSON.stringify(newGeneralRegistry))
  }

  static hasEvent(purchaseUUID: string, eventName: string): boolean {
    const purchaseEventsRegistry = LocalStorageProxy.getItem(`vp-event-${purchaseUUID}`)
    if (!purchaseEventsRegistry) {
      return false
    }

    const events = purchaseEventsRegistry.split(',').filter((item) => item.length)

    for (let i = 0; i < events.length; i++) {
      if (eventName === events[i]) {
        return true
      }
    }

    return false
  }

  static pushEvent(purchaseUUID: string, eventName: string) {
    this.addToGeneralRegistryAndCleanOld(purchaseUUID)
    if (this.hasEvent(purchaseUUID, eventName)) {
      return
    }

    let purchaseEventsRegistry = LocalStorageProxy.getItem(`vp-event-${purchaseUUID}`)

    if (purchaseEventsRegistry) {
      purchaseEventsRegistry += `,${eventName}`
    } else {
      purchaseEventsRegistry = eventName
    }

    LocalStorageProxy.setItem(`vp-event-${purchaseUUID}`, purchaseEventsRegistry)
  }
}
